import type { QuotedPlanVm } from '~/models/quoting/QuotedPlan'

export default class FitScore {
  static use() {
    const engine = EngineStore.use()

    // the score is a mystery until the plan has something personal to score against
    const isMystery = (quote: QuotedPlanVm) =>
      !(
        quote.hasDrugs ||
        quote.hasProviders ||
        quote.hasPharmacy ||
        engine.params.surveyAnswers?.length
      )

    return {
      isMystery
    }
  }
}
